<template>
  <BlockLoading v-if="isPending" class="py-6" />

  <BlockError
    v-else-if="error"
    can-retry
    class="py-6"
    @retry="refetch"
  >
    <p><strong>Error loading block</strong></p>
    <p>{{ error?.message }}</p>
    <p v-if="isGridUnityAdmin && !siteScope" class="text-center">
      No "siteScope" set for "PresetLinksBlock" in projects.dashboard.config.json override.
    </p>
  </BlockError>
    
  <div
    v-else 
    :class="['card', classes.card ]"
  >
    <div class="card-header-icon">
      <h2 class="h4 mb-0">{{ title }}</h2>
      <i class="bx bx-task" aria-hidden="true" />
    </div>

    <div class="card-body p-0">
      <ul :class="['list-group list-group-secondary list-group-flush overflow-y-auto', classes.listGroup]">
        <template v-if="items.length < 1">
          <div class="list-group-item">
            <div v-html="noItemsMessageHtml" />
          </div>
        </template>
        <a
          v-for="(item, index) in items"
          v-else
          :key="index"
          :href="`/projects/?presetId=${item.presetId}`"
          :class="['list-group-item list-group-item-action list-group-item-kvp', `list-group-item-${item.variant}`]"
        >
          {{ item.presetName }}
          <span :class="`badge text-bg-${item.variant || 'light'} rounded-pill ms-3`">{{ formatNumber(item.count) }}</span>
        </a>
      </ul>
    </div>
  </div>
</template>

<script setup>
import { storeToRefs } from 'pinia'
import { ref, toRefs, watch } from 'vue'

import BlockError from '@shared/components/BlockError.vue'
import BlockLoading from '@shared/components/BlockLoading.vue'
import { formatNumber } from '@shared/utils/number'

import { getSiteScopePresetCounts } from '@projects/api/dashboard.api'

import { useAuthStore } from '@projects/stores/AuthStore'
const authStore = useAuthStore()

const props = defineProps({
  classes: {
    type: Object,
    default: () => ({}),
  },
  noItemsMessageHtml: {
    type: String,
    default: 'No filter preset configured for display',
  },
  title: {
    type: String,
    required: true,
  },
  siteScope: {
    type: String,
    required: true,
  },
})

const { 
  classes,
  noItemsMessageHtml,
  siteScope,
  title,
} = toRefs(props)
const items = ref([])
const { isGridUnityAdmin } = storeToRefs(authStore)

const {
  data,
  error,
  isPending,
  refetch,
} = getSiteScopePresetCounts(siteScope.value)

watch(data, (newData) => {
  if (!newData) return
  items.value = newData.data || []
})
</script>
